import React, { useEffect } from 'react';
import StyledBox from 'views/rebranded-module/tours-module/ToursLandingViewV2/ToursLandingViewV2.styles';
import { useContent } from 'views/rebranded-module/common/context/useContent';
import { HeroSection } from 'views/rebranded-module/tours-module/ToursLandingViewV2/components/HeroSection';
import {
  IconicRidersSection,
  IconicRidersSectionSkeleton,
} from 'views/rebranded-module/tours-module/ToursLandingViewV2/components/IconicRidersSection';
import { Box, Container } from '@mui/material';
import {
  OffRoadPromoSection,
  OffRoadPromoSectionSkeleton,
} from 'views/rebranded-module/tours-module/ToursLandingViewV2/components/OffRoadPromoSection';
import {
  CustomExperienceSection,
  CustomExperienceSectionSkeleton,
} from 'views/rebranded-module/tours-module/ToursLandingViewV2/components/CustomExperienceSection';
import { ImgBox, LazyLoad } from 'views/common/components';
import { scrollToAnchor } from 'views/common/utils/scrollToAnchor';
import useAdabtiveMultiSizeImage from 'views/common/hooks/useAdabtiveMultiSizeImage';

const ToursLandingViewV2 = (props) => {
  const { serverData: pageData, initWidgetData } = props;
  const cmsData = useContent('ToursLandingPage');
  const getSizedImage = useAdabtiveMultiSizeImage();

  useEffect(() => {
    scrollToAnchor();
  }, []);

  return (
    <StyledBox>
      <Box>
        <HeroSection initWidgetData={initWidgetData} />
      </Box>
      <Box className="TLVIconicSectionContainer">
        {cmsData?.iconicBackground?.sizes && (
          <Box className="TLVBGImageContainer">
            <ImgBox
              image={{
                src: getSizedImage(cmsData.iconicBackground.sizes),
                alt: cmsData.iconicBackground?.alt,
              }}
              width="100%"
              height="100%"
            />
          </Box>
        )}
        <Box className="TLIconicBackground" id="iconic-rides-section" />
        <Container maxWidth="xxl" className=" TLConatiner TLIconicContainer">
          <LazyLoad
            skeleton={<IconicRidersSectionSkeleton />}
            dataLoaded={!!pageData}>
            <IconicRidersSection iconicRides={pageData.experience_pages} />
          </LazyLoad>
        </Container>
      </Box>
      <LazyLoad
        skeleton={<OffRoadPromoSectionSkeleton />}
        dataLoaded={!!pageData}>
        <OffRoadPromoSection />
      </LazyLoad>
      <Container maxWidth="xxl" className="TLConatiner">
        <LazyLoad
          skeleton={<CustomExperienceSectionSkeleton />}
          dataLoaded={!!pageData}>
          <CustomExperienceSection pageData={pageData} />
        </LazyLoad>
      </Container>
    </StyledBox>
  );
};

export { ToursLandingViewV2 };
